import React from "react";
import { Input } from "@heroui/react";
import { Icon } from "@iconify/react";

const YearInput = ({
    label,
    value,
    onChange,
    isReadOnly = false,
    className = "",
    icon = "lucide:calendar",
    minYear = 2010,
    maxYear = 2035,
    ...props
}) => {
    // Función para validar si el año está en el rango permitido
    const isValidYear = (year) => {
        const yearNum = parseInt(year);
        return !isNaN(yearNum) && yearNum >= minYear && yearNum <= maxYear;
    };

    // Función para formatear el año (solo números, 4 dígitos)
    const formatYear = (input) => {
        // Remover caracteres no numéricos
        const numericOnly = input.replace(/[^\d]/g, "");
        
        // Limitar a 4 dígitos
        return numericOnly.slice(0, 4);
    };

    // Manejador de cambio
    const handleChange = (e) => {
        const formattedValue = formatYear(e.target.value);
        e.target.value = formattedValue;
        
        if (onChange) {
            onChange(formattedValue);
        }
    };

    // Manejador de blur para validar
    const handleBlur = (e) => {
        const year = e.target.value;
        if (year && !isValidYear(year)) {
            // Si el año no es válido, limpiar el campo
            e.target.value = "";
            if (onChange) {
                onChange("");
            }
        }
    };

    return (
        <Input
            label={label}
            value={value || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={`${minYear}-${maxYear}`}
            startContent={
                <Icon
                    icon={icon}
                    className="text-default-400 pointer-events-none flex-shrink-0"
                />
            }
            classNames={{
                label: "text-sm font-medium",
                input: "text-sm",
            }}
            isReadOnly={isReadOnly}
            className={className}
            {...props}
        />
    );
};

export default YearInput; 